import { Plugin } from 'vue';
import VueLogger from 'vuejs3-logger';

const LoggerPlugin: Plugin =
{
    install(app)
    {
        const options = {
            // required ['debug', 'info', 'warn', 'error', 'fatal']
            logLevel: import.meta.env.PROD ? 'fatal' : 'debug',
            stringifyArguments: false,
            showLogLevel: true,
            showMethodName: false,
            separator: '|',
            showConsoleColors: true
        };

        app.use(VueLogger, options);

        app.config.errorHandler = (err, instance, info) =>
        {
            app.config.globalProperties.$log.error(info, err);
        };

        app.config.warnHandler = (msg, instance, trace) =>
        {
            app.config.globalProperties.$log.warn(msg, trace);
        };
    }
};

export default LoggerPlugin;
